import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Item B4: log every load over 4s (page, endpoint, duration) for Admin → Slow pages.
api.interceptors.request.use((cfg) => {
  cfg.metadata = { start: Date.now() };
  if (localStorage.getItem("truva_show_test") === "1") cfg.headers["X-Show-Test"] = "1";
  const pv = localStorage.getItem("truva_preview_as");
  if (pv) cfg.headers["X-Preview-As"] = pv;
  return cfg;
});
const logSlow = (cfg) => {
  const ms = Date.now() - (cfg?.metadata?.start || Date.now());
  if (ms > 4000 && cfg?.url && !cfg.url.includes("/perf-log")) {
    api.post("/perf-log", { page: window.location.pathname, endpoint: cfg.url, ms }).catch(() => {});
  }
};
api.interceptors.response.use((r) => { logSlow(r.config); return r; }, (e) => {
  if (e?.config) logSlow(e.config);
  if (e?.response?.status === 403 && e.response.data?.detail === "Preview only — changes are off") {
    import("sonner").then(({ toast }) => toast.info("Preview only — changes are off"));
  }
  return Promise.reject(e);
});

export default api;
